export default function Navbar() {
  return (
    <nav className="navigation">
      <div className="nav-items">
        <h1 className="website-title">Where in the World?</h1>
        <button className="theme-button">Dark Mode</button>
      </div>
    </nav>
  );
}
